import { initials, tint } from "@shared/lib/tint";
import { FileImage } from "@shared/ui/FileImage";

/**
 * Значок сервера — та же плашка, круглая, как у человека.
 *
 * Картинка встаёт поверх инициалов, как у человека: коробка одна и та же, и
 * ряд серверов не разъезжается от того, что у половины из них значок есть, а
 * у половины нет.
 */
export function ServerTile({
  name,
  id,
  iconId,
  size = 42,
}: {
  name: string;
  id: string;
  iconId?: string | null;
  size?: number;
}) {
  return (
    <span
      className="tile-box server-tile"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.38),
        background: tint(id),
      }}
    >
      {iconId ? (
        <FileImage id={iconId} alt="" width={size} height={size} />
      ) : (
        initials(name)
      )}
    </span>
  );
}
